export default "__VITE_ASSET__DzZhC0ey__"